import CustomButton from '@/app/customComponents/CustomButton/CustomButton';
import CustomDatePicker from '@shared/customComponents/CustomDatePicker/CustomDatePicker';
import { getRoomFeeds } from '@/app/services/rooms/rooms';
import * as Actions from '@/app/store/actions';
import {
	Avatar,
	CircularProgress,
	FormControl,
	IconButton,
	InputLabel,
	MenuItem,
	Paper,
	Select,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
} from '@material-ui/core';
import { ArrowForwardIos } from '@material-ui/icons';
import Close from '@material-ui/icons/Close';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import './roomspage.css';
import { useNavigate } from 'react-router-dom';

const Roomstd = ({ room }) => {
	const dispatch = useDispatch();
	const [rows, setRows] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [firstLoad, setFirstLoad] = useState(true);
	const [start_date, setStart_date] = useState('');
	const [end_date, setEnd_date] = useState('');
	const [activity_type, setActivity_type] = useState('');
	const navigate = useNavigate();

	useEffect(() => {
		let isMounted = true;
		setIsLoading(true);
		const payload = {
			id: room.id,
			start_date,
			end_date,
			activity_type,
		};
		getRoomFeeds(payload)
			.then((res) => {
				if (!isMounted) return null;
				setRows(res.data.activities);
				setFirstLoad(false);
			})
			.catch(() => {
				dispatch(
					Actions.showMessage({
						message: 'Failed to fetch data, please refresh',
						variant: 'error',
					})
				);
			})
			.finally(() => {
				if (!isMounted) return null;
				setIsLoading(false);
			});
		return () => {
			isMounted = false;
		};
	}, []);

	const ApplyFilters = () => {
		setIsLoading(true);
		const payload = {
			id: room.id,
			start_date,
			end_date,
			activity_type,
		};
		getRoomFeeds({ ...payload })
			.then((res) => {
				setRows(res.data.activities);
			})
			.catch(() => {
				dispatch(
					Actions.showMessage({
						message: 'Failed to fetch data, please refresh',
						variant: 'error',
					})
				);
			})
			.finally(() => {
				setIsLoading(false);
			});
	};

	const goToFeedsDetails = (row) => {
		navigate(`/rooms-FeedsType/${row.id}`, { state: { room: room } });
	};

	return (
		<div className="mx-auto room-width">
			<div className="flex mt-10 items-center flex-nowrap justify-between">
				<span className="text-pd-2xl self-end  mr-28" style={{ fontSize: '20px', fontWeight: '700' }}>
					<IconButton
						className="h-44 w-44"
						onClick={() => {
							navigate('/rooms');
						}}
					>
						<img alt="filter" className="backBtn-img" src="assets/images/arrow-long.png" width="24px" />
					</IconButton>

					{room.name}
				</span>{' '}
				<div className="flex justify-between">
					<div className="flex">
						<span className="mx-10">
							{' '}
							{/* <TextField
									id="start_date"
									label="Date from"
									type="date"
									name="start_date"
									// InputProps={{
									// 	inputProps: { max: end_date || new Date().toISOString().split('T')[0] }
									// }}
									onChange={ev => setStart_date(ev.target.value)}
									value={start_date}
									className={classes.textField}
									InputLabelProps={{
										shrink: true
									}}
								/> */}
							<CustomDatePicker
								disableFuture
								label="Date from"
								maxDate={end_date || undefined}
								setValue={(date) => setStart_date(date?.format('YYYY-MM-DD') || '')}
								value={start_date}
							/>
						</span>
						<span className="mr-20 ml-10">
							{' '}
							{/* <TextField
									id="end_date"
									label="Date to"
									name="end_date"
									// InputProps={{
									// 	inputProps: { min: start_date, max: new Date().toISOString().split('T')[0] }
									// }}
									value={end_date}
									onChange={ev => setEnd_date(ev.target.value)}
									type="date"
									className={classes.textField}
									InputLabelProps={{
										shrink: true
									}}
								/> */}
							<CustomDatePicker
								disableFuture
								label="Date to"
								minDate={start_date || undefined}
								setValue={(date) => setEnd_date(date?.format('YYYY-MM-DD') || '')}
								value={end_date}
							/>
						</span>
						<div className="mx-8">
							<FormControl>
								<InputLabel id="filterLabel">Filter</InputLabel>
								<Select
									endAdornment={
										activity_type ? (
											<IconButton className="mr-16" onClick={() => setActivity_type('')} size="small">
												<Close fontSize="small" />
											</IconButton>
										) : (
											''
										)
									}
									id="activity_type"
									label="Filter"
									labelId="filterlabel"
									name="activity_type"
									onChange={(ev) => setActivity_type(ev.target.value)}
									style={{ width: 150 }}
									value={activity_type}
								>
									<MenuItem value={1}>Diaper</MenuItem>
									<MenuItem value={2}>Meals</MenuItem>
									<MenuItem value={3}>Nap</MenuItem>
									<MenuItem value={4}>Potty</MenuItem>
									<MenuItem value={5}>Bottle</MenuItem>
									<MenuItem value={6}>Lesson</MenuItem>
									<MenuItem value={7}>Centers</MenuItem>
									<MenuItem value={8}>Outdoor Learning</MenuItem>
									<MenuItem value={9}>FaceLink&trade;</MenuItem>
								</Select>
							</FormControl>
						</div>
					</div>
					<div className="self-end">
						<span>
							<span className="mx-4">
								<CustomButton
									fontSize="15px"
									height="43"
									onClick={() => {
										ApplyFilters();
									}}
									variant="primary"
									width="140px"
								>
									Apply
								</CustomButton>
							</span>
						</span>
					</div>
				</div>
			</div>
			<TableContainer className="room-table-cont" component={Paper} id="Scrollable-table">
				<Table className="rooms-table" stickyHeader style={{ width: '100%' }}>
					<TableHead>
						<TableRow>
							<TableCell className="bg-white roomsTableHeader" style={{ width: '30%' }}>
								Activity Type
							</TableCell>
							<TableCell className="bg-white roomsTableHeader" style={{ width: '70%' }}>
								Students
							</TableCell>
							<TableCell className="bg-white roomsTableHeader" />
						</TableRow>
					</TableHead>

					<TableBody className="">
						{isLoading ? (
							<TableRow>
								<TableCell align="center" colSpan={8}>
									<CircularProgress size={35} />
								</TableCell>
							</TableRow>
						) : (
							(!rows.length && !firstLoad && (
								<TableRow>
									<TableCell align="center" colSpan={8}>
										No Feeds to show
									</TableCell>
								</TableRow>
							)) ||
							rows?.map((row) => {
								return (
									<TableRow key={row.id}>
										<TableCell component="th" scope="row">
											<div
												className="flex cursor-pointer"
												onClick={() => goToFeedsDetails(row)}
												onKeyDown={(e) => {
													if (e.key === 'Enter') {
														goToFeedsDetails(row);
													}
												}}
												role="button"
												tabIndex={0}
											>
												<div className="flex items-center">
													<Avatar className="mr-16" src={row.photo} />
													<div className="rooms-school-name">{row.name}</div>
												</div>
											</div>
										</TableCell>
										<TableCell>
											<div className="flex items-center" style={{ gap: 5 }}>
												<div className="flex">
													{row.students.map((student, index) => {
														return index < 4 ? (
															<Avatar
																className="student-icon"
																key={index}
																src={student?.photo}
																style={{ marginRight: 5 }}
															/>
														) : (
															''
														);
													})}
												</div>
												<div className="rooms-student-count justify-between">
													&nbsp;
													{row.students_count > 4 ? `${row.students_count - 4} other students` : null}
												</div>
											</div>
										</TableCell>
										<TableCell>
											<div>
												<ArrowForwardIos style={{ color: 'grey', fontSize: '14px' }} />
											</div>
										</TableCell>
									</TableRow>
								);
							})
						)}
					</TableBody>
				</Table>
			</TableContainer>
		</div>
	);
};

export default Roomstd;
